import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { of, throwError } from 'rxjs';
import * as MessagesActions from './messages.actions';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../shared/services/toast.service';
import { MessageService } from '../services/message.services';
import { IMessage } from '../model/message.model';

@Injectable()
export class MessageEffects {
  constructor(private actions$: Actions,
      private messageService: MessageService,
      private toastService: ToastService,
      private translate: TranslateService) {}

  sendMessagesEffect$ = createEffect(() => this.actions$.pipe(
    ofType(MessagesActions.sendMessage),
    switchMap((action) =>
      this.messageService.sendMessage(action.message, action.destinationId).pipe(
        map(message => {
          return MessagesActions.sendMessageSentSuccess({message})
        }),
        catchError(() => {
          this.toastService.Error(this.translate.instant("message.errorSending"), '');
          return of(MessagesActions.sendMessageSentFailure({ error: 'Error sending message' }))
          }
        )
      )
    )
  ));

  getMessagesEffect$ = createEffect(() =>
    this.actions$.pipe(
    ofType(MessagesActions.getMessages),
    switchMap((action) => this.messageService.getMessages(action.destinationId).pipe(
        map(messages => {
          return MessagesActions.getMessagesSuccess(messages);
        })
      )
    )
  ));

  getConversationEffect$ = createEffect(() => this.actions$.pipe(
    ofType(MessagesActions.getConversations),
    switchMap(() =>
      this.messageService.getConversations().pipe(
        map(conversations => MessagesActions.getConversationsSuccess({conversations}))
      )
    )
  ));

  deleteMessageEffect$ = createEffect(() => this.actions$.pipe(
      ofType(MessagesActions.deleteMessage),
      switchMap((action) =>
        this.messageService.deleteMessage(action.messageId).pipe(
          map(message => {
            this.toastService.Success(this.translate.instant("Message.myMessages.cancelled"), '');
            return MessagesActions.deleteMessageSentSuccess({message})
          }),
          catchError(() => of(MessagesActions.deleteMessageSentFailure({ error: 'Error cancelling Message' })))
        )
      )
    )
  );

  getMessageContactsSuccess$ = createEffect(() =>
    this.actions$.pipe(
    ofType(MessagesActions.getMessageContacts),
    switchMap(_ => this.messageService.getMessageContacts().pipe(
        map(messages => {
          return MessagesActions.getMessageContactsSuccess(messages);
        })
      )
    )
  ));



}
